module.exports = __webpack_public_path__ + "img/tv.a80ca1.svg";